/**
 * Created by Rodrigo Quesada on 17/02/17.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {NavigableNode} from './navigable-node.class';
import {Screen} from './screen.class';
import {AuthService} from '../../security/authorization/auth.service';
import {UserImpersonationService} from '../../../domain/model/user/user-impersonation.service';
import keys = require('core-js/fn/object/keys');

export abstract class ScreensManager {

    screenChange$: Observable<boolean>;

    private _refreshing$ = new BehaviorSubject(false);
    refreshed$: Observable<boolean> = this._refreshing$.map(value => !value);

    protected _currentScreen?: Screen;

    private _urlRegex: RegExp;

    set path(value: string) {
        this._urlRegex = new RegExp(`^${value.replace(/:[^\/]+/g, '[^\\/]+')}$`);
    }

    protected _pathFromRoot: string;

    constructor(private readonly _smgm: ScreensManagerDeps) {}

    init(parent: NavigableNode<any, any>) {
        this.path = parent.path;
        this._pathFromRoot = parent.pathFromRoot();
        this._smgm.impersonationService.impersonatedUserChange$
            .switchMap(() => this._smgm.impersonationService.dataRefreshed$.first())
            .switchMap(() => this._smgm.authService.userIsLoggedIn$.first())
            .switchMap(value => {
                if (value) return this.refresh();
                else return Observable.of(true);
            }).subscribe(() => {});
    }

    setCurrentScreen(screen: Screen|undefined, route: ActivatedRouteSnapshot) {
        this._currentScreen = screen;
    }

    abstract hasPreviousScreen(): boolean;

    abstract hasNextScreen(): boolean;

    previousScreenId(): string|number|undefined { return undefined; }

    abstract navigateToPreviousScreen(): Observable<boolean>;

    nextScreenId(): string|number|undefined { return undefined; }

    abstract navigateToNextScreen(): Observable<boolean>;

    firstScreenId(): string|number|undefined { return undefined; }

    abstract navigateToFirstScreen(): Observable<boolean>;

    lastScreenId(): string|number|undefined { return undefined; }

    abstract navigateToLastScreen(): Observable<boolean>;

    pathMatches(path: string): boolean {
        return this._urlRegex.test(path);
    }

    protected _pathFromRootUsing(params: any) {
        let result: string = this._pathFromRoot;
        keys(params).forEach(param => {
            result = result.replace(`:${param}`, params[param]);
        });
        return result;
    }

    refresh(): Observable<boolean> {
        return Observable.of(true).flatMap(() => {
            this._refreshing$.next(true);
            return this._doRefresh();
        }).do(() => this._refreshing$.next(false));
    }

    protected abstract _doRefresh(): Observable<boolean>;

    skip(): boolean { return false; }
}

@Injectable()
export class ScreensManagerDeps {
    constructor(readonly authService: AuthService, readonly impersonationService: UserImpersonationService) {
    }
}

export abstract class IdBasedNavigationScreensManager extends ScreensManager {

    constructor(smgm: ScreensManagerDeps) {
        super(smgm);
    }

    navigateToPreviousScreen(): Observable<boolean> {
        return Observable.of(true);
    }

    navigateToNextScreen(): Observable<boolean> {
        return Observable.of(true);
    }

    navigateToFirstScreen(): Observable<boolean> {
        return Observable.of(true);
    }

    navigateToLastScreen(): Observable<boolean> {
        return Observable.of(true);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/service/screen-manager.class.ts